import { TherapistAction } from '../../actions/constant';

const {
  THERAPIST_PROFILE_SUCCESS,
  THERAPIST_PROFILE_FAILURE,
  THERAPIST_PROFILE_RESET,
  THERAPIST_PROFILE_REQUEST,
  PRE_THERAPIST_PROFILE_REQUEST,
  PRE_THERAPIST_PROFILE_SUCCESS,
  PRE_THERAPIST_PROFILE_FAILURE,
} = TherapistAction;

const intitialstate: object = {
  getAdminProfile: false,
  response: null,
  loader: false,
};

export const getTherapistProfileReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case THERAPIST_PROFILE_SUCCESS:
    case PRE_THERAPIST_PROFILE_SUCCESS: {
      return {
        ...state,
        getAdminProfile: true,
        response: action.payload,
        loader: false,
      };
    }

    case THERAPIST_PROFILE_FAILURE:
    case PRE_THERAPIST_PROFILE_FAILURE:
      return {
        ...state,
        getAdminProfile: false,
        response: action.payload,
        loader: false,
      };

    case THERAPIST_PROFILE_REQUEST:
    case PRE_THERAPIST_PROFILE_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case THERAPIST_PROFILE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
